var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppBarPage",
    {
      attrs: { title: _vm.title },
      scopedSlots: _vm._u([
        {
          key: "subNav",
          fn: function () {
            return [_c("DeviceTopNav")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("DeprecationWarningBanner", {
        staticStyle: { "margin-bottom": "1em" },
      }),
      _c("div", [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }